<script>
export default {
  props: {
    title: {
      type: String,
      required: true
    },
    icon: {
      type: String,
      required: false,
      default: null
    }
  }
};
</script>

<template>
  <div class="header">
    <img v-if="icon" :src="icon" />

    <div>{{ title }}</div>
  </div>
</template>

<style lang="scss" scoped>
.header {
  width: 100%;
  margin-bottom: 16px;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  user-select: none;
}

.header > img {
  width: 19px;
  height: 19px;
  margin-right: 8px;
}

.header > div {
  font-size: 16px;
  font-weight: 400;
  text-align: center;
}

.header:after {
  width: 100px;
  height: 1px;
  position: absolute;
  bottom: -8px;
  left: calc(50% - 50px);
  content: "";
  background: #603285;
}

@media (min-width: 768px) {
  .header {
    margin-bottom: 20px;
  }

  .header > img {
    width: 24px;
    height: 24px;
    margin-right: 12px;
  }

  .header > div {
    font-size: 20px;
  }
}

@media (min-width: 1024px) {
  .header {
    margin-bottom: 24px;
  }

  .header > img {
    width: 28px;
    height: 28px;
    margin-right: 16px;
  }

  .header > div {
    font-size: 24px;
    text-align: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/_Shared/Title.vue